import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CaptionRow from '../components/CaptionRow';
import CircleButton from '../components/CircleButton';
import Divider from '../components/Divider';
// import LanguageButton from '../components/LanguageButton';
import PortraitStage from '../components/PortraitStage';
import ScreenHeader from '../components/ScreenHeader';
import { ArrowRight, LayersIcon } from '../components/icons';
import { clearContribution } from '../utils/contribution';
import { clearTicket } from '../utils/ticket';

function HomeScreen() {
  const navigate = useNavigate();

  useEffect(() => {
    clearTicket();
    clearContribution();

    // Pull the latest service worker / assets whenever home is shown.
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistration().then((registration) => {
        registration?.update().catch(() => {});
      });
    }
  }, []);

  return (
    <PortraitStage>
      <section className="home" aria-labelledby="home-title">
        <ScreenHeader
          title="Mosida"
          subtitle="Social Collage"
          // action={<LanguageButton />}
        />

        <main className="home__main">
          <div className="home__copy">
            <h1 id="home-title" className="home__title">
              Dear Miami
            </h1>
            <p className="home__prompt">
              What would you say to Miami
              <br />
              if the city could hear you?
            </p>
          </div>

          <CircleButton
            label="Start"
            icon={<ArrowRight />}
            onClick={() => navigate('/scan')}
          />
        </main>

        <footer className="home__footer">
          <Divider />
          <CaptionRow icon={<LayersIcon />}>
            Your contribution becomes part
            <br />
            of the collective artwork.
          </CaptionRow>
        </footer>
      </section>
    </PortraitStage>
  );
}

export default HomeScreen;
